module.exports = __webpack_public_path__ + "static/media/float_button_jp.51bc720f.png";